import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';
import { getph, getSentry } from '../lib/vendor';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('tp_user');
    const token  = localStorage.getItem('tp_token');
    if (stored && token) {
      setUser(JSON.parse(stored));
      // Verify token is still valid
      api.get('/api/auth/me').then(res => {
        setUser(res.data);
        localStorage.setItem('tp_user', JSON.stringify(res.data));
      }).catch(() => logout());
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('tp_token', token);
    localStorage.setItem('tp_user', JSON.stringify(userData));
    setUser(userData);
    getph()?.identify(String(userData.id), { email: userData.email, role: userData.role });
    getSentry()?.setUser({ id: String(userData.id), email: userData.email });
  };

  const logout = () => {
    localStorage.removeItem('tp_token');
    localStorage.removeItem('tp_user');
    setUser(null);
    getph()?.reset();
    getSentry()?.setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await api.get('/api/auth/me');
      setUser(res.data);
      localStorage.setItem('tp_user', JSON.stringify(res.data));
    } catch (_) {}
  };

  // Mise à jour partielle synchrone du user (évite la race condition navigate)
  const patchUser = (updates) => {
    setUser(u => {
      const updated = { ...u, ...updates };
      localStorage.setItem('tp_user', JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, refreshUser, patchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
